import LecturerMode from '@component/lecturer-mode/LecturerMode';
import PureAudioMode from '@component/pureAudio-mode/PureAudioMode';
import { useAppSelector } from '@store/hooks';
import { getMeetingDisplayMode } from '@store/studio/studio.slice';
import { MeetingDisplayMode } from 'src/type/meeting';
import HostTips from '@component/host-tips';
import RecordState from '@component/record-state';
import './Studio.scss';
import VoiceActivityDetection from '@component/voice-activity-detection ';
import { isMobileBrowser } from '@utils/browser';

/**
 * 重点
 *
 * 1. 区分三种模式: 演讲者模式 / 纯音频模式 / 平铺模式
 *  平铺模式/宫格模式现在没有，有需求单
 *
 * 2. 小画面列表
 *
 *
 */
export default function Studio() {
  const mode = useAppSelector(getMeetingDisplayMode);

  return (
    <div className="studio">
      {/* 所有流的音频都在这里播放 */}
      <div id="audio-wrapper" />
      {/** 录制状态 */}
      <RecordState />

      {/* TODO 这里可以做一层缓存，避免切换重复渲染 */}
      {mode === MeetingDisplayMode.Lecturer && <LecturerMode />}
      {mode === MeetingDisplayMode.PureAudio && <PureAudioMode />}

      {/* 用户静音的时候检测有无说话，进行提示 */}
      <VoiceActivityDetection />

      {/* 主持人下载客户端提示 */}
      {isMobileBrowser() ? null : <HostTips />}
    </div>
  );
}
